// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/supervisor/v1/supervisor.proto" (package "agency.supervisor.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { SessionConfig } from "../../session/v1/session";
import { Duration } from "../../../google/protobuf/duration";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * ActorSpawnRequest requests spawning a new actor.
 *
 * @generated from protobuf message agency.supervisor.v1.ActorSpawnRequest
 */
export interface ActorSpawnRequest {
    /**
     * actor_type is the type of actor to spawn.
     *
     * @generated from protobuf field: string actor_type = 1
     */
    actorType: string;
    /**
     * actor_id uniquely identifies this actor instance.
     *
     * @generated from protobuf field: string actor_id = 2
     */
    actorId: string;
    /**
     * parent_id is the parent actor (if applicable).
     *
     * @generated from protobuf field: string parent_id = 3
     */
    parentId: string;
    /**
     * config contains actor-specific configuration.
     *
     * @generated from protobuf field: map<string, string> config = 4
     */
    config: {
        [key: string]: string;
    };
    /**
     * supervision_strategy defines restart behavior.
     *
     * @generated from protobuf field: agency.supervisor.v1.SupervisionStrategy supervision_strategy = 5
     */
    supervisionStrategy?: SupervisionStrategy;
}
/**
 * ActorSpawnResponse confirms actor creation.
 *
 * @generated from protobuf message agency.supervisor.v1.ActorSpawnResponse
 */
export interface ActorSpawnResponse {
    /**
     * actor_id is the spawned actor identifier.
     *
     * @generated from protobuf field: string actor_id = 1
     */
    actorId: string;
    /**
     * spawned_at is when the actor was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp spawned_at = 2
     */
    spawnedAt?: Timestamp;
    /**
     * pid is the Hollywood actor PID.
     *
     * @generated from protobuf field: string pid = 3
     */
    pid: string;
}
/**
 * ActorStopRequest requests stopping an actor.
 *
 * @generated from protobuf message agency.supervisor.v1.ActorStopRequest
 */
export interface ActorStopRequest {
    /**
     * actor_id is the actor to stop.
     *
     * @generated from protobuf field: string actor_id = 1
     */
    actorId: string;
    /**
     * graceful allows the actor to finish in-flight operations.
     *
     * @generated from protobuf field: bool graceful = 2
     */
    graceful: boolean;
    /**
     * timeout is the graceful shutdown timeout.
     *
     * @generated from protobuf field: google.protobuf.Duration timeout = 3
     */
    timeout?: Duration;
    /**
     * reason explains why the actor is being stopped.
     *
     * @generated from protobuf field: string reason = 4
     */
    reason: string;
}
/**
 * ActorStopResponse confirms actor termination.
 *
 * @generated from protobuf message agency.supervisor.v1.ActorStopResponse
 */
export interface ActorStopResponse {
    /**
     * actor_id is the stopped actor identifier.
     *
     * @generated from protobuf field: string actor_id = 1
     */
    actorId: string;
    /**
     * stopped_at is when the actor terminated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp stopped_at = 2
     */
    stoppedAt?: Timestamp;
    /**
     * graceful_shutdown indicates if shutdown was graceful.
     *
     * @generated from protobuf field: bool graceful_shutdown = 3
     */
    gracefulShutdown: boolean;
}
/**
 * ActorRestartEvent signals actor restart.
 *
 * @generated from protobuf message agency.supervisor.v1.ActorRestartEvent
 */
export interface ActorRestartEvent {
    /**
     * actor_id is the restarted actor.
     *
     * @generated from protobuf field: string actor_id = 1
     */
    actorId: string;
    /**
     * actor_type is the actor type.
     *
     * @generated from protobuf field: string actor_type = 2
     */
    actorType: string;
    /**
     * restart_count is the number of restarts within the supervision window.
     *
     * @generated from protobuf field: int32 restart_count = 3
     */
    restartCount: number;
    /**
     * failure_reason explains why the actor failed.
     *
     * @generated from protobuf field: string failure_reason = 4
     */
    failureReason: string;
    /**
     * restarted_at is when the restart occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp restarted_at = 5
     */
    restartedAt?: Timestamp;
    /**
     * backoff_duration is the delay before restart.
     *
     * @generated from protobuf field: google.protobuf.Duration backoff_duration = 6
     */
    backoffDuration?: Duration;
}
/**
 * SupervisionExhaustedEvent signals restart limit reached.
 *
 * @generated from protobuf message agency.supervisor.v1.SupervisionExhaustedEvent
 */
export interface SupervisionExhaustedEvent {
    /**
     * actor_id is the failed actor.
     *
     * @generated from protobuf field: string actor_id = 1
     */
    actorId: string;
    /**
     * actor_type is the actor type.
     *
     * @generated from protobuf field: string actor_type = 2
     */
    actorType: string;
    /**
     * restart_count is the total restart attempts.
     *
     * @generated from protobuf field: int32 restart_count = 3
     */
    restartCount: number;
    /**
     * window_duration is the supervision window.
     *
     * @generated from protobuf field: google.protobuf.Duration window_duration = 4
     */
    windowDuration?: Duration;
    /**
     * exhausted_at is when supervision gave up.
     *
     * @generated from protobuf field: google.protobuf.Timestamp exhausted_at = 5
     */
    exhaustedAt?: Timestamp;
    /**
     * final_error is the last error before exhaustion.
     *
     * @generated from protobuf field: string final_error = 6
     */
    finalError: string;
}
/**
 * SupervisionStrategy defines restart behavior.
 *
 * @generated from protobuf message agency.supervisor.v1.SupervisionStrategy
 */
export interface SupervisionStrategy {
    /**
     * max_restarts is the maximum restart attempts within the window.
     *
     * @generated from protobuf field: int32 max_restarts = 1
     */
    maxRestarts: number;
    /**
     * window is the time window for counting restarts.
     *
     * @generated from protobuf field: google.protobuf.Duration window = 2
     */
    window?: Duration;
    /**
     * backoff are exponential backoff durations.
     *
     * @generated from protobuf field: repeated google.protobuf.Duration backoff = 3
     */
    backoff: Duration[];
    /**
     * max_backoff caps the exponential backoff.
     *
     * @generated from protobuf field: google.protobuf.Duration max_backoff = 4
     */
    maxBackoff?: Duration;
    /**
     * strategy_type defines the supervision strategy.
     *
     * @generated from protobuf field: agency.supervisor.v1.SupervisionStrategyType strategy_type = 5
     */
    strategyType: SupervisionStrategyType;
}
/**
 * ActorHealthCheck requests actor health status.
 *
 * @generated from protobuf message agency.supervisor.v1.ActorHealthCheck
 */
export interface ActorHealthCheck {
    /**
     * actor_id is the actor to check.
     *
     * @generated from protobuf field: string actor_id = 1
     */
    actorId: string;
    /**
     * include_children includes child actor health.
     *
     * @generated from protobuf field: bool include_children = 2
     */
    includeChildren: boolean;
}
/**
 * ActorHealthResponse returns actor health status.
 *
 * @generated from protobuf message agency.supervisor.v1.ActorHealthResponse
 */
export interface ActorHealthResponse {
    /**
     * actor_id is the checked actor.
     *
     * @generated from protobuf field: string actor_id = 1
     */
    actorId: string;
    /**
     * healthy indicates if the actor is healthy.
     *
     * @generated from protobuf field: bool healthy = 2
     */
    healthy: boolean;
    /**
     * state is the current actor state.
     *
     * @generated from protobuf field: agency.supervisor.v1.ActorState state = 3
     */
    state: ActorState;
    /**
     * children are child actor health statuses (if requested).
     *
     * @generated from protobuf field: repeated agency.supervisor.v1.ActorHealthResponse children = 4
     */
    children: ActorHealthResponse[];
    /**
     * last_restart_at is when the actor last restarted (if applicable).
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_restart_at = 5
     */
    lastRestartAt?: Timestamp;
    /**
     * restart_count is the restart count within the current window.
     *
     * @generated from protobuf field: int32 restart_count = 6
     */
    restartCount: number;
}
/**
 * SupervisorTree represents the actor hierarchy.
 *
 * @generated from protobuf message agency.supervisor.v1.SupervisorTree
 */
export interface SupervisorTree {
    /**
     * root is the root supervisor.
     *
     * @generated from protobuf field: agency.supervisor.v1.ActorNode root = 1
     */
    root?: ActorNode;
    /**
     * total_actors is the count of all actors in the tree.
     *
     * @generated from protobuf field: int32 total_actors = 2
     */
    totalActors: number;
    /**
     * snapshot_at is when this tree snapshot was taken.
     *
     * @generated from protobuf field: google.protobuf.Timestamp snapshot_at = 3
     */
    snapshotAt?: Timestamp;
}
/**
 * ActorNode represents a node in the supervisor tree.
 *
 * @generated from protobuf message agency.supervisor.v1.ActorNode
 */
export interface ActorNode {
    /**
     * actor_id is the actor identifier.
     *
     * @generated from protobuf field: string actor_id = 1
     */
    actorId: string;
    /**
     * actor_type is the actor type.
     *
     * @generated from protobuf field: string actor_type = 2
     */
    actorType: string;
    /**
     * state is the current actor state.
     *
     * @generated from protobuf field: agency.supervisor.v1.ActorState state = 3
     */
    state: ActorState;
    /**
     * children are child actors supervised by this actor.
     *
     * @generated from protobuf field: repeated agency.supervisor.v1.ActorNode children = 4
     */
    children: ActorNode[];
    /**
     * spawned_at is when the actor was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp spawned_at = 5
     */
    spawnedAt?: Timestamp;
    /**
     * restart_count is the restart count within the current window.
     *
     * @generated from protobuf field: int32 restart_count = 6
     */
    restartCount: number;
}
/**
 * SupervisionDefaults defines per-actor-type supervision defaults.
 *
 * @generated from protobuf message agency.supervisor.v1.SupervisionDefaults
 */
export interface SupervisionDefaults {
    /**
     * actor_type_pattern is a regex pattern matching actor types.
     *
     * @generated from protobuf field: string actor_type_pattern = 1
     */
    actorTypePattern: string;
    /**
     * strategy is the default supervision strategy for matching actors.
     *
     * @generated from protobuf field: agency.supervisor.v1.SupervisionStrategy strategy = 2
     */
    strategy?: SupervisionStrategy;
}
/**
 * WorkspaceSpawnRequest spawns a WorkspaceActor with tenant isolation.
 *
 * @generated from protobuf message agency.supervisor.v1.WorkspaceSpawnRequest
 */
export interface WorkspaceSpawnRequest {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * supervision_strategy overrides default supervision for this workspace.
     *
     * @generated from protobuf field: agency.supervisor.v1.SupervisionStrategy supervision_strategy = 3
     */
    supervisionStrategy?: SupervisionStrategy;
    /**
     * config contains workspace-specific configuration.
     *
     * @generated from protobuf field: map<string, string> config = 4
     */
    config: {
        [key: string]: string;
    };
}
/**
 * WorkspaceSpawnResponse confirms WorkspaceActor creation.
 *
 * @generated from protobuf message agency.supervisor.v1.WorkspaceSpawnResponse
 */
export interface WorkspaceSpawnResponse {
    /**
     * workspace_id is the tenant.workspace identifier.
     *
     * @generated from protobuf field: string workspace_id = 1
     */
    workspaceId: string;
    /**
     * actor_id is the spawned WorkspaceActor identifier.
     *
     * @generated from protobuf field: string actor_id = 2
     */
    actorId: string;
    /**
     * spawned_at is when the workspace was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp spawned_at = 3
     */
    spawnedAt?: Timestamp;
    /**
     * pid is the Hollywood actor PID.
     *
     * @generated from protobuf field: string pid = 4
     */
    pid: string;
}
/**
 * SessionSpawnRequest spawns a SessionActor with ContextReady semantics.
 *
 * @generated from protobuf message agency.supervisor.v1.SessionSpawnRequest
 */
export interface SessionSpawnRequest {
    /**
     * session_urn uniquely identifies the session (urn:session:tenant:workspace:id).
     *
     * @generated from protobuf field: string session_urn = 1
     */
    sessionUrn: string;
    /**
     * workspace_pid is the parent WorkspaceActor PID.
     *
     * @generated from protobuf field: string workspace_pid = 2
     */
    workspacePid: string;
    /**
     * context_ready_timeout is the deadline for receiving ContextReady.
     *
     * @generated from protobuf field: google.protobuf.Duration context_ready_timeout = 3
     */
    contextReadyTimeout?: Duration;
    /**
     * session_config is the session configuration.
     *
     * @generated from protobuf field: agency.session.v1.SessionConfig session_config = 4
     */
    sessionConfig?: SessionConfig;
    /**
     * supervision_strategy overrides default supervision for this session.
     *
     * @generated from protobuf field: agency.supervisor.v1.SupervisionStrategy supervision_strategy = 5
     */
    supervisionStrategy?: SupervisionStrategy;
    /**
     * config contains session-specific actor configuration.
     *
     * @generated from protobuf field: map<string, string> config = 6
     */
    config: {
        [key: string]: string;
    };
}
/**
 * SessionSpawnResponse confirms SessionActor creation.
 *
 * @generated from protobuf message agency.supervisor.v1.SessionSpawnResponse
 */
export interface SessionSpawnResponse {
    /**
     * session_id is the session identifier.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * actor_id is the spawned SessionActor identifier.
     *
     * @generated from protobuf field: string actor_id = 2
     */
    actorId: string;
    /**
     * spawned_at is when the session was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp spawned_at = 3
     */
    spawnedAt?: Timestamp;
    /**
     * pid is the Hollywood actor PID.
     *
     * @generated from protobuf field: string pid = 4
     */
    pid: string;
    /**
     * context_ready_deadline is when ContextReady timeout expires.
     *
     * @generated from protobuf field: google.protobuf.Timestamp context_ready_deadline = 5
     */
    contextReadyDeadline?: Timestamp;
}
/**
 * SessionLifecycleEvent signals session lifecycle transitions.
 *
 * @generated from protobuf message agency.supervisor.v1.SessionLifecycleEvent
 */
export interface SessionLifecycleEvent {
    /**
     * session_id is the session identifier.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * session_urn is the full session URN.
     *
     * @generated from protobuf field: string session_urn = 2
     */
    sessionUrn: string;
    /**
     * lifecycle_stage indicates the transition.
     *
     * @generated from protobuf field: agency.supervisor.v1.SessionLifecycleStage lifecycle_stage = 3
     */
    lifecycleStage: SessionLifecycleStage;
    /**
     * timestamp is when the transition occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 4
     */
    timestamp?: Timestamp;
    /**
     * reason explains the transition (for failures).
     *
     * @generated from protobuf field: string reason = 5
     */
    reason: string;
}
/**
 * BoundedContextSpawnRequest spawns a bounded context supervisor with children.
 *
 * @generated from protobuf message agency.supervisor.v1.BoundedContextSpawnRequest
 */
export interface BoundedContextSpawnRequest {
    /**
     * context_name identifies the bounded context (audit, observability, billing, etc).
     *
     * @generated from protobuf field: string context_name = 1
     */
    contextName: string;
    /**
     * supervisor_type is the supervisor actor type.
     *
     * @generated from protobuf field: string supervisor_type = 2
     */
    supervisorType: string;
    /**
     * children are the child actors to spawn under this supervisor.
     *
     * @generated from protobuf field: repeated agency.supervisor.v1.ActorSpawnRequest children = 3
     */
    children: ActorSpawnRequest[];
    /**
     * supervision_strategy defines supervision for this bounded context.
     *
     * @generated from protobuf field: agency.supervisor.v1.SupervisionStrategy supervision_strategy = 4
     */
    supervisionStrategy?: SupervisionStrategy;
    /**
     * config contains bounded-context-specific configuration.
     *
     * @generated from protobuf field: map<string, string> config = 5
     */
    config: {
        [key: string]: string;
    };
}
/**
 * BoundedContextSpawnResponse confirms bounded context supervisor creation.
 *
 * @generated from protobuf message agency.supervisor.v1.BoundedContextSpawnResponse
 */
export interface BoundedContextSpawnResponse {
    /**
     * context_name is the bounded context identifier.
     *
     * @generated from protobuf field: string context_name = 1
     */
    contextName: string;
    /**
     * supervisor_id is the spawned supervisor actor identifier.
     *
     * @generated from protobuf field: string supervisor_id = 2
     */
    supervisorId: string;
    /**
     * supervisor_pid is the Hollywood supervisor PID.
     *
     * @generated from protobuf field: string supervisor_pid = 3
     */
    supervisorPid: string;
    /**
     * children are the spawned child actors.
     *
     * @generated from protobuf field: repeated agency.supervisor.v1.ActorSpawnResponse children = 4
     */
    children: ActorSpawnResponse[];
    /**
     * spawned_at is when the bounded context was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp spawned_at = 5
     */
    spawnedAt?: Timestamp;
}
/**
 * SupervisionStrategyType defines how supervision handles failures.
 *
 * @generated from protobuf enum agency.supervisor.v1.SupervisionStrategyType
 */
export enum SupervisionStrategyType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: SUPERVISION_STRATEGY_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * ONE_FOR_ONE restarts only the failed actor.
     *
     * @generated from protobuf enum value: SUPERVISION_STRATEGY_TYPE_ONE_FOR_ONE = 1;
     */
    ONE_FOR_ONE = 1,
    /**
     * ALL_FOR_ONE restarts all sibling actors.
     *
     * @generated from protobuf enum value: SUPERVISION_STRATEGY_TYPE_ALL_FOR_ONE = 2;
     */
    ALL_FOR_ONE = 2,
    /**
     * REST_FOR_ONE restarts the failed actor and all actors started after it.
     *
     * @generated from protobuf enum value: SUPERVISION_STRATEGY_TYPE_REST_FOR_ONE = 3;
     */
    REST_FOR_ONE = 3
}
/**
 * ActorState represents the actor lifecycle state.
 *
 * @generated from protobuf enum agency.supervisor.v1.ActorState
 */
export enum ActorState {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: ACTOR_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * STARTING indicates the actor is initializing.
     *
     * @generated from protobuf enum value: ACTOR_STATE_STARTING = 1;
     */
    STARTING = 1,
    /**
     * RUNNING indicates the actor is operational.
     *
     * @generated from protobuf enum value: ACTOR_STATE_RUNNING = 2;
     */
    RUNNING = 2,
    /**
     * STOPPING indicates graceful shutdown in progress.
     *
     * @generated from protobuf enum value: ACTOR_STATE_STOPPING = 3;
     */
    STOPPING = 3,
    /**
     * STOPPED indicates the actor has terminated.
     *
     * @generated from protobuf enum value: ACTOR_STATE_STOPPED = 4;
     */
    STOPPED = 4,
    /**
     * FAILED indicates the actor has failed.
     *
     * @generated from protobuf enum value: ACTOR_STATE_FAILED = 5;
     */
    FAILED = 5,
    /**
     * RESTARTING indicates restart in progress.
     *
     * @generated from protobuf enum value: ACTOR_STATE_RESTARTING = 6;
     */
    RESTARTING = 6
}
/**
 * SessionLifecycleStage represents session lifecycle transitions.
 *
 * @generated from protobuf enum agency.supervisor.v1.SessionLifecycleStage
 */
export enum SessionLifecycleStage {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: SESSION_LIFECYCLE_STAGE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * SPAWNED indicates SessionActor created, waiting for ContextReady.
     *
     * @generated from protobuf enum value: SESSION_LIFECYCLE_STAGE_SPAWNED = 1;
     */
    SPAWNED = 1,
    /**
     * CONTEXT_READY indicates ContextReady received, session operational.
     *
     * @generated from protobuf enum value: SESSION_LIFECYCLE_STAGE_CONTEXT_READY = 2;
     */
    CONTEXT_READY = 2,
    /**
     * CONTEXT_TIMEOUT indicates ContextReady not received before deadline.
     *
     * @generated from protobuf enum value: SESSION_LIFECYCLE_STAGE_CONTEXT_TIMEOUT = 3;
     */
    CONTEXT_TIMEOUT = 3,
    /**
     * TERMINATED indicates session stopped (graceful or failure).
     *
     * @generated from protobuf enum value: SESSION_LIFECYCLE_STAGE_TERMINATED = 4;
     */
    TERMINATED = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class ActorSpawnRequest$Type extends MessageType<ActorSpawnRequest> {
    constructor() {
        super("agency.supervisor.v1.ActorSpawnRequest", [
            { no: 1, name: "actor_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[A-Z][a-zA-Z0-9]*Actor$" } } } },
            { no: 2, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "parent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 4, name: "config", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "8192" } } } } } },
            { no: 5, name: "supervision_strategy", kind: "message", T: () => SupervisionStrategy }
        ]);
    }
    create(value?: PartialMessage<ActorSpawnRequest>): ActorSpawnRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actorType = "";
        message.actorId = "";
        message.parentId = "";
        message.config = {};
        if (value !== undefined)
            reflectionMergePartial<ActorSpawnRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorSpawnRequest): ActorSpawnRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string actor_type */ 1:
                    message.actorType = reader.string();
                    break;
                case /* string actor_id */ 2:
                    message.actorId = reader.string();
                    break;
                case /* string parent_id */ 3:
                    message.parentId = reader.string();
                    break;
                case /* map<string, string> config */ 4:
                    this.binaryReadMap4(message.config, reader, options);
                    break;
                case /* agency.supervisor.v1.SupervisionStrategy supervision_strategy */ 5:
                    message.supervisionStrategy = SupervisionStrategy.internalBinaryRead(reader, reader.uint32(), options, message.supervisionStrategy);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: ActorSpawnRequest["config"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ActorSpawnRequest["config"] | undefined, val: ActorSpawnRequest["config"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.supervisor.v1.ActorSpawnRequest.config");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ActorSpawnRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string actor_type = 1; */
        if (message.actorType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actorType);
        /* string actor_id = 2; */
        if (message.actorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.actorId);
        /* string parent_id = 3; */
        if (message.parentId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.parentId);
        /* map<string, string> config = 4; */
        for (let k of globalThis.Object.keys(message.config))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.config[k]).join();
        /* agency.supervisor.v1.SupervisionStrategy supervision_strategy = 5; */
        if (message.supervisionStrategy)
            SupervisionStrategy.internalBinaryWrite(message.supervisionStrategy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.ActorSpawnRequest
 */
export const ActorSpawnRequest = new ActorSpawnRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorSpawnResponse$Type extends MessageType<ActorSpawnResponse> {
    constructor() {
        super("agency.supervisor.v1.ActorSpawnResponse", [
            { no: 1, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "spawned_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "pid", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<ActorSpawnResponse>): ActorSpawnResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actorId = "";
        message.pid = "";
        if (value !== undefined)
            reflectionMergePartial<ActorSpawnResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorSpawnResponse): ActorSpawnResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string actor_id */ 1:
                    message.actorId = reader.string();
                    break;
                case /* google.protobuf.Timestamp spawned_at */ 2:
                    message.spawnedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.spawnedAt);
                    break;
                case /* string pid */ 3:
                    message.pid = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActorSpawnResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string actor_id = 1; */
        if (message.actorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actorId);
        /* google.protobuf.Timestamp spawned_at = 2; */
        if (message.spawnedAt)
            Timestamp.internalBinaryWrite(message.spawnedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string pid = 3; */
        if (message.pid !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.ActorSpawnResponse
 */
export const ActorSpawnResponse = new ActorSpawnResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorStopRequest$Type extends MessageType<ActorStopRequest> {
    constructor() {
        super("agency.supervisor.v1.ActorStopRequest", [
            { no: 1, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "graceful", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "timeout", kind: "message", T: () => Duration },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ActorStopRequest>): ActorStopRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actorId = "";
        message.graceful = false;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<ActorStopRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorStopRequest): ActorStopRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string actor_id */ 1:
                    message.actorId = reader.string();
                    break;
                case /* bool graceful */ 2:
                    message.graceful = reader.bool();
                    break;
                case /* google.protobuf.Duration timeout */ 3:
                    message.timeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.timeout);
                    break;
                case /* string reason */ 4:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActorStopRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string actor_id = 1; */
        if (message.actorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actorId);
        /* bool graceful = 2; */
        if (message.graceful !== false)
            writer.tag(2, WireType.Varint).bool(message.graceful);
        /* google.protobuf.Duration timeout = 3; */
        if (message.timeout)
            Duration.internalBinaryWrite(message.timeout, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string reason = 4; */
        if (message.reason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.ActorStopRequest
 */
export const ActorStopRequest = new ActorStopRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorStopResponse$Type extends MessageType<ActorStopResponse> {
    constructor() {
        super("agency.supervisor.v1.ActorStopResponse", [
            { no: 1, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "stopped_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "graceful_shutdown", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ActorStopResponse>): ActorStopResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actorId = "";
        message.gracefulShutdown = false;
        if (value !== undefined)
            reflectionMergePartial<ActorStopResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorStopResponse): ActorStopResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string actor_id */ 1:
                    message.actorId = reader.string();
                    break;
                case /* google.protobuf.Timestamp stopped_at */ 2:
                    message.stoppedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.stoppedAt);
                    break;
                case /* bool graceful_shutdown */ 3:
                    message.gracefulShutdown = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActorStopResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string actor_id = 1; */
        if (message.actorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actorId);
        /* google.protobuf.Timestamp stopped_at = 2; */
        if (message.stoppedAt)
            Timestamp.internalBinaryWrite(message.stoppedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool graceful_shutdown = 3; */
        if (message.gracefulShutdown !== false)
            writer.tag(3, WireType.Varint).bool(message.gracefulShutdown);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.ActorStopResponse
 */
export const ActorStopResponse = new ActorStopResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorRestartEvent$Type extends MessageType<ActorRestartEvent> {
    constructor() {
        super("agency.supervisor.v1.ActorRestartEvent", [
            { no: 1, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "actor_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "restart_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 1 } } } },
            { no: 4, name: "failure_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 5, name: "restarted_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "backoff_duration", kind: "message", T: () => Duration }
        ]);
    }
    create(value?: PartialMessage<ActorRestartEvent>): ActorRestartEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actorId = "";
        message.actorType = "";
        message.restartCount = 0;
        message.failureReason = "";
        if (value !== undefined)
            reflectionMergePartial<ActorRestartEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorRestartEvent): ActorRestartEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string actor_id */ 1:
                    message.actorId = reader.string();
                    break;
                case /* string actor_type */ 2:
                    message.actorType = reader.string();
                    break;
                case /* int32 restart_count */ 3:
                    message.restartCount = reader.int32();
                    break;
                case /* string failure_reason */ 4:
                    message.failureReason = reader.string();
                    break;
                case /* google.protobuf.Timestamp restarted_at */ 5:
                    message.restartedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.restartedAt);
                    break;
                case /* google.protobuf.Duration backoff_duration */ 6:
                    message.backoffDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.backoffDuration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActorRestartEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string actor_id = 1; */
        if (message.actorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actorId);
        /* string actor_type = 2; */
        if (message.actorType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.actorType);
        /* int32 restart_count = 3; */
        if (message.restartCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.restartCount);
        /* string failure_reason = 4; */
        if (message.failureReason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.failureReason);
        /* google.protobuf.Timestamp restarted_at = 5; */
        if (message.restartedAt)
            Timestamp.internalBinaryWrite(message.restartedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration backoff_duration = 6; */
        if (message.backoffDuration)
            Duration.internalBinaryWrite(message.backoffDuration, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.ActorRestartEvent
 */
export const ActorRestartEvent = new ActorRestartEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SupervisionExhaustedEvent$Type extends MessageType<SupervisionExhaustedEvent> {
    constructor() {
        super("agency.supervisor.v1.SupervisionExhaustedEvent", [
            { no: 1, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "actor_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "restart_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 1 } } } },
            { no: 4, name: "window_duration", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "exhausted_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "final_error", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } }
        ]);
    }
    create(value?: PartialMessage<SupervisionExhaustedEvent>): SupervisionExhaustedEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actorId = "";
        message.actorType = "";
        message.restartCount = 0;
        message.finalError = "";
        if (value !== undefined)
            reflectionMergePartial<SupervisionExhaustedEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SupervisionExhaustedEvent): SupervisionExhaustedEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string actor_id */ 1:
                    message.actorId = reader.string();
                    break;
                case /* string actor_type */ 2:
                    message.actorType = reader.string();
                    break;
                case /* int32 restart_count */ 3:
                    message.restartCount = reader.int32();
                    break;
                case /* google.protobuf.Duration window_duration */ 4:
                    message.windowDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.windowDuration);
                    break;
                case /* google.protobuf.Timestamp exhausted_at */ 5:
                    message.exhaustedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.exhaustedAt);
                    break;
                case /* string final_error */ 6:
                    message.finalError = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SupervisionExhaustedEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string actor_id = 1; */
        if (message.actorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actorId);
        /* string actor_type = 2; */
        if (message.actorType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.actorType);
        /* int32 restart_count = 3; */
        if (message.restartCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.restartCount);
        /* google.protobuf.Duration window_duration = 4; */
        if (message.windowDuration)
            Duration.internalBinaryWrite(message.windowDuration, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp exhausted_at = 5; */
        if (message.exhaustedAt)
            Timestamp.internalBinaryWrite(message.exhaustedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string final_error = 6; */
        if (message.finalError !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.finalError);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.SupervisionExhaustedEvent
 */
export const SupervisionExhaustedEvent = new SupervisionExhaustedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SupervisionStrategy$Type extends MessageType<SupervisionStrategy> {
    constructor() {
        super("agency.supervisor.v1.SupervisionStrategy", [
            { no: 1, name: "max_restarts", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 1 } } } },
            { no: 2, name: "window", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "backoff", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Duration, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "10" } } } },
            { no: 4, name: "max_backoff", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "strategy_type", kind: "enum", T: () => ["agency.supervisor.v1.SupervisionStrategyType", SupervisionStrategyType, "SUPERVISION_STRATEGY_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } }
        ]);
    }
    create(value?: PartialMessage<SupervisionStrategy>): SupervisionStrategy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.maxRestarts = 0;
        message.backoff = [];
        message.strategyType = 0;
        if (value !== undefined)
            reflectionMergePartial<SupervisionStrategy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SupervisionStrategy): SupervisionStrategy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 max_restarts */ 1:
                    message.maxRestarts = reader.int32();
                    break;
                case /* google.protobuf.Duration window */ 2:
                    message.window = Duration.internalBinaryRead(reader, reader.uint32(), options, message.window);
                    break;
                case /* repeated google.protobuf.Duration backoff */ 3:
                    message.backoff.push(Duration.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Duration max_backoff */ 4:
                    message.maxBackoff = Duration.internalBinaryRead(reader, reader.uint32(), options, message.maxBackoff);
                    break;
                case /* agency.supervisor.v1.SupervisionStrategyType strategy_type */ 5:
                    message.strategyType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SupervisionStrategy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 max_restarts = 1; */
        if (message.maxRestarts !== 0)
            writer.tag(1, WireType.Varint).int32(message.maxRestarts);
        /* google.protobuf.Duration window = 2; */
        if (message.window)
            Duration.internalBinaryWrite(message.window, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Duration backoff = 3; */
        for (let i = 0; i < message.backoff.length; i++)
            Duration.internalBinaryWrite(message.backoff[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration max_backoff = 4; */
        if (message.maxBackoff)
            Duration.internalBinaryWrite(message.maxBackoff, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* agency.supervisor.v1.SupervisionStrategyType strategy_type = 5; */
        if (message.strategyType !== 0)
            writer.tag(5, WireType.Varint).int32(message.strategyType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.SupervisionStrategy
 */
export const SupervisionStrategy = new SupervisionStrategy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorHealthCheck$Type extends MessageType<ActorHealthCheck> {
    constructor() {
        super("agency.supervisor.v1.ActorHealthCheck", [
            { no: 1, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "include_children", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ActorHealthCheck>): ActorHealthCheck {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actorId = "";
        message.includeChildren = false;
        if (value !== undefined)
            reflectionMergePartial<ActorHealthCheck>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorHealthCheck): ActorHealthCheck {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string actor_id */ 1:
                    message.actorId = reader.string();
                    break;
                case /* bool include_children */ 2:
                    message.includeChildren = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActorHealthCheck, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string actor_id = 1; */
        if (message.actorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actorId);
        /* bool include_children = 2; */
        if (message.includeChildren !== false)
            writer.tag(2, WireType.Varint).bool(message.includeChildren);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.ActorHealthCheck
 */
export const ActorHealthCheck = new ActorHealthCheck$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorHealthResponse$Type extends MessageType<ActorHealthResponse> {
    constructor() {
        super("agency.supervisor.v1.ActorHealthResponse", [
            { no: 1, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "healthy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "state", kind: "enum", T: () => ["agency.supervisor.v1.ActorState", ActorState, "ACTOR_STATE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "children", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActorHealthResponse },
            { no: 5, name: "last_restart_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "restart_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<ActorHealthResponse>): ActorHealthResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actorId = "";
        message.healthy = false;
        message.state = 0;
        message.children = [];
        message.restartCount = 0;
        if (value !== undefined)
            reflectionMergePartial<ActorHealthResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorHealthResponse): ActorHealthResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string actor_id */ 1:
                    message.actorId = reader.string();
                    break;
                case /* bool healthy */ 2:
                    message.healthy = reader.bool();
                    break;
                case /* agency.supervisor.v1.ActorState state */ 3:
                    message.state = reader.int32();
                    break;
                case /* repeated agency.supervisor.v1.ActorHealthResponse children */ 4:
                    message.children.push(ActorHealthResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp last_restart_at */ 5:
                    message.lastRestartAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastRestartAt);
                    break;
                case /* int32 restart_count */ 6:
                    message.restartCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActorHealthResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string actor_id = 1; */
        if (message.actorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actorId);
        /* bool healthy = 2; */
        if (message.healthy !== false)
            writer.tag(2, WireType.Varint).bool(message.healthy);
        /* agency.supervisor.v1.ActorState state = 3; */
        if (message.state !== 0)
            writer.tag(3, WireType.Varint).int32(message.state);
        /* repeated agency.supervisor.v1.ActorHealthResponse children = 4; */
        for (let i = 0; i < message.children.length; i++)
            ActorHealthResponse.internalBinaryWrite(message.children[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_restart_at = 5; */
        if (message.lastRestartAt)
            Timestamp.internalBinaryWrite(message.lastRestartAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int32 restart_count = 6; */
        if (message.restartCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.restartCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.ActorHealthResponse
 */
export const ActorHealthResponse = new ActorHealthResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SupervisorTree$Type extends MessageType<SupervisorTree> {
    constructor() {
        super("agency.supervisor.v1.SupervisorTree", [
            { no: 1, name: "root", kind: "message", T: () => ActorNode, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "total_actors", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 1 } } } },
            { no: 3, name: "snapshot_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<SupervisorTree>): SupervisorTree {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.totalActors = 0;
        if (value !== undefined)
            reflectionMergePartial<SupervisorTree>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SupervisorTree): SupervisorTree {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.supervisor.v1.ActorNode root */ 1:
                    message.root = ActorNode.internalBinaryRead(reader, reader.uint32(), options, message.root);
                    break;
                case /* int32 total_actors */ 2:
                    message.totalActors = reader.int32();
                    break;
                case /* google.protobuf.Timestamp snapshot_at */ 3:
                    message.snapshotAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.snapshotAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SupervisorTree, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.supervisor.v1.ActorNode root = 1; */
        if (message.root)
            ActorNode.internalBinaryWrite(message.root, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_actors = 2; */
        if (message.totalActors !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalActors);
        /* google.protobuf.Timestamp snapshot_at = 3; */
        if (message.snapshotAt)
            Timestamp.internalBinaryWrite(message.snapshotAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.SupervisorTree
 */
export const SupervisorTree = new SupervisorTree$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorNode$Type extends MessageType<ActorNode> {
    constructor() {
        super("agency.supervisor.v1.ActorNode", [
            { no: 1, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "actor_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "state", kind: "enum", T: () => ["agency.supervisor.v1.ActorState", ActorState, "ACTOR_STATE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "children", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActorNode },
            { no: 5, name: "spawned_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "restart_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<ActorNode>): ActorNode {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actorId = "";
        message.actorType = "";
        message.state = 0;
        message.children = [];
        message.restartCount = 0;
        if (value !== undefined)
            reflectionMergePartial<ActorNode>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorNode): ActorNode {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string actor_id */ 1:
                    message.actorId = reader.string();
                    break;
                case /* string actor_type */ 2:
                    message.actorType = reader.string();
                    break;
                case /* agency.supervisor.v1.ActorState state */ 3:
                    message.state = reader.int32();
                    break;
                case /* repeated agency.supervisor.v1.ActorNode children */ 4:
                    message.children.push(ActorNode.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp spawned_at */ 5:
                    message.spawnedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.spawnedAt);
                    break;
                case /* int32 restart_count */ 6:
                    message.restartCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActorNode, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string actor_id = 1; */
        if (message.actorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actorId);
        /* string actor_type = 2; */
        if (message.actorType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.actorType);
        /* agency.supervisor.v1.ActorState state = 3; */
        if (message.state !== 0)
            writer.tag(3, WireType.Varint).int32(message.state);
        /* repeated agency.supervisor.v1.ActorNode children = 4; */
        for (let i = 0; i < message.children.length; i++)
            ActorNode.internalBinaryWrite(message.children[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp spawned_at = 5; */
        if (message.spawnedAt)
            Timestamp.internalBinaryWrite(message.spawnedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int32 restart_count = 6; */
        if (message.restartCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.restartCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.ActorNode
 */
export const ActorNode = new ActorNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SupervisionDefaults$Type extends MessageType<SupervisionDefaults> {
    constructor() {
        super("agency.supervisor.v1.SupervisionDefaults", [
            { no: 1, name: "actor_type_pattern", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256", pattern: "^[A-Z][a-zA-Z0-9*.*?]+$" } } } },
            { no: 2, name: "strategy", kind: "message", T: () => SupervisionStrategy, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<SupervisionDefaults>): SupervisionDefaults {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actorTypePattern = "";
        if (value !== undefined)
            reflectionMergePartial<SupervisionDefaults>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SupervisionDefaults): SupervisionDefaults {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string actor_type_pattern */ 1:
                    message.actorTypePattern = reader.string();
                    break;
                case /* agency.supervisor.v1.SupervisionStrategy strategy */ 2:
                    message.strategy = SupervisionStrategy.internalBinaryRead(reader, reader.uint32(), options, message.strategy);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SupervisionDefaults, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string actor_type_pattern = 1; */
        if (message.actorTypePattern !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actorTypePattern);
        /* agency.supervisor.v1.SupervisionStrategy strategy = 2; */
        if (message.strategy)
            SupervisionStrategy.internalBinaryWrite(message.strategy, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.SupervisionDefaults
 */
export const SupervisionDefaults = new SupervisionDefaults$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkspaceSpawnRequest$Type extends MessageType<WorkspaceSpawnRequest> {
    constructor() {
        super("agency.supervisor.v1.WorkspaceSpawnRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "supervision_strategy", kind: "message", T: () => SupervisionStrategy },
            { no: 4, name: "config", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "8192" } } } } } }
        ]);
    }
    create(value?: PartialMessage<WorkspaceSpawnRequest>): WorkspaceSpawnRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.config = {};
        if (value !== undefined)
            reflectionMergePartial<WorkspaceSpawnRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkspaceSpawnRequest): WorkspaceSpawnRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* agency.supervisor.v1.SupervisionStrategy supervision_strategy */ 3:
                    message.supervisionStrategy = SupervisionStrategy.internalBinaryRead(reader, reader.uint32(), options, message.supervisionStrategy);
                    break;
                case /* map<string, string> config */ 4:
                    this.binaryReadMap4(message.config, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: WorkspaceSpawnRequest["config"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof WorkspaceSpawnRequest["config"] | undefined, val: WorkspaceSpawnRequest["config"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.supervisor.v1.WorkspaceSpawnRequest.config");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: WorkspaceSpawnRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* agency.supervisor.v1.SupervisionStrategy supervision_strategy = 3; */
        if (message.supervisionStrategy)
            SupervisionStrategy.internalBinaryWrite(message.supervisionStrategy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> config = 4; */
        for (let k of globalThis.Object.keys(message.config))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.config[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.WorkspaceSpawnRequest
 */
export const WorkspaceSpawnRequest = new WorkspaceSpawnRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkspaceSpawnResponse$Type extends MessageType<WorkspaceSpawnResponse> {
    constructor() {
        super("agency.supervisor.v1.WorkspaceSpawnResponse", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "spawned_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "pid", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkspaceSpawnResponse>): WorkspaceSpawnResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.workspaceId = "";
        message.actorId = "";
        message.pid = "";
        if (value !== undefined)
            reflectionMergePartial<WorkspaceSpawnResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkspaceSpawnResponse): WorkspaceSpawnResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string workspace_id */ 1:
                    message.workspaceId = reader.string();
                    break;
                case /* string actor_id */ 2:
                    message.actorId = reader.string();
                    break;
                case /* google.protobuf.Timestamp spawned_at */ 3:
                    message.spawnedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.spawnedAt);
                    break;
                case /* string pid */ 4:
                    message.pid = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkspaceSpawnResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string workspace_id = 1; */
        if (message.workspaceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.workspaceId);
        /* string actor_id = 2; */
        if (message.actorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.actorId);
        /* google.protobuf.Timestamp spawned_at = 3; */
        if (message.spawnedAt)
            Timestamp.internalBinaryWrite(message.spawnedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string pid = 4; */
        if (message.pid !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.WorkspaceSpawnResponse
 */
export const WorkspaceSpawnResponse = new WorkspaceSpawnResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionSpawnRequest$Type extends MessageType<SessionSpawnRequest> {
    constructor() {
        super("agency.supervisor.v1.SessionSpawnRequest", [
            { no: 1, name: "session_urn", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256", pattern: "^urn:session:[a-z0-9][a-z0-9-]*:[a-z0-9][a-z0-9-]*:[a-z0-9][a-z0-9-]*$" } } } },
            { no: 2, name: "workspace_pid", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "context_ready_timeout", kind: "message", T: () => Duration, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "session_config", kind: "message", T: () => SessionConfig, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "supervision_strategy", kind: "message", T: () => SupervisionStrategy },
            { no: 6, name: "config", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "8192" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SessionSpawnRequest>): SessionSpawnRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionUrn = "";
        message.workspacePid = "";
        message.config = {};
        if (value !== undefined)
            reflectionMergePartial<SessionSpawnRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionSpawnRequest): SessionSpawnRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_urn */ 1:
                    message.sessionUrn = reader.string();
                    break;
                case /* string workspace_pid */ 2:
                    message.workspacePid = reader.string();
                    break;
                case /* google.protobuf.Duration context_ready_timeout */ 3:
                    message.contextReadyTimeout = Duration.internalBinaryRead(reader, reader.uint32(), options, message.contextReadyTimeout);
                    break;
                case /* agency.session.v1.SessionConfig session_config */ 4:
                    message.sessionConfig = SessionConfig.internalBinaryRead(reader, reader.uint32(), options, message.sessionConfig);
                    break;
                case /* agency.supervisor.v1.SupervisionStrategy supervision_strategy */ 5:
                    message.supervisionStrategy = SupervisionStrategy.internalBinaryRead(reader, reader.uint32(), options, message.supervisionStrategy);
                    break;
                case /* map<string, string> config */ 6:
                    this.binaryReadMap6(message.config, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: SessionSpawnRequest["config"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SessionSpawnRequest["config"] | undefined, val: SessionSpawnRequest["config"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.supervisor.v1.SessionSpawnRequest.config");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: SessionSpawnRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_urn = 1; */
        if (message.sessionUrn !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionUrn);
        /* string workspace_pid = 2; */
        if (message.workspacePid !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspacePid);
        /* google.protobuf.Duration context_ready_timeout = 3; */
        if (message.contextReadyTimeout)
            Duration.internalBinaryWrite(message.contextReadyTimeout, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.session.v1.SessionConfig session_config = 4; */
        if (message.sessionConfig)
            SessionConfig.internalBinaryWrite(message.sessionConfig, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* agency.supervisor.v1.SupervisionStrategy supervision_strategy = 5; */
        if (message.supervisionStrategy)
            SupervisionStrategy.internalBinaryWrite(message.supervisionStrategy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> config = 6; */
        for (let k of globalThis.Object.keys(message.config))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.config[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.SessionSpawnRequest
 */
export const SessionSpawnRequest = new SessionSpawnRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionSpawnResponse$Type extends MessageType<SessionSpawnResponse> {
    constructor() {
        super("agency.supervisor.v1.SessionSpawnResponse", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "spawned_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "pid", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 5, name: "context_ready_deadline", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<SessionSpawnResponse>): SessionSpawnResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.actorId = "";
        message.pid = "";
        if (value !== undefined)
            reflectionMergePartial<SessionSpawnResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionSpawnResponse): SessionSpawnResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string actor_id */ 2:
                    message.actorId = reader.string();
                    break;
                case /* google.protobuf.Timestamp spawned_at */ 3:
                    message.spawnedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.spawnedAt);
                    break;
                case /* string pid */ 4:
                    message.pid = reader.string();
                    break;
                case /* google.protobuf.Timestamp context_ready_deadline */ 5:
                    message.contextReadyDeadline = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.contextReadyDeadline);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionSpawnResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string actor_id = 2; */
        if (message.actorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.actorId);
        /* google.protobuf.Timestamp spawned_at = 3; */
        if (message.spawnedAt)
            Timestamp.internalBinaryWrite(message.spawnedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string pid = 4; */
        if (message.pid !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pid);
        /* google.protobuf.Timestamp context_ready_deadline = 5; */
        if (message.contextReadyDeadline)
            Timestamp.internalBinaryWrite(message.contextReadyDeadline, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.SessionSpawnResponse
 */
export const SessionSpawnResponse = new SessionSpawnResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionLifecycleEvent$Type extends MessageType<SessionLifecycleEvent> {
    constructor() {
        super("agency.supervisor.v1.SessionLifecycleEvent", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "session_urn", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "lifecycle_stage", kind: "enum", T: () => ["agency.supervisor.v1.SessionLifecycleStage", SessionLifecycleStage, "SESSION_LIFECYCLE_STAGE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } }
        ]);
    }
    create(value?: PartialMessage<SessionLifecycleEvent>): SessionLifecycleEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.sessionUrn = "";
        message.lifecycleStage = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<SessionLifecycleEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionLifecycleEvent): SessionLifecycleEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string session_urn */ 2:
                    message.sessionUrn = reader.string();
                    break;
                case /* agency.supervisor.v1.SessionLifecycleStage lifecycle_stage */ 3:
                    message.lifecycleStage = reader.int32();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 4:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* string reason */ 5:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionLifecycleEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string session_urn = 2; */
        if (message.sessionUrn !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionUrn);
        /* agency.supervisor.v1.SessionLifecycleStage lifecycle_stage = 3; */
        if (message.lifecycleStage !== 0)
            writer.tag(3, WireType.Varint).int32(message.lifecycleStage);
        /* google.protobuf.Timestamp timestamp = 4; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string reason = 5; */
        if (message.reason !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.SessionLifecycleEvent
 */
export const SessionLifecycleEvent = new SessionLifecycleEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BoundedContextSpawnRequest$Type extends MessageType<BoundedContextSpawnRequest> {
    constructor() {
        super("agency.supervisor.v1.BoundedContextSpawnRequest", [
            { no: 1, name: "context_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z][a-z_]*[a-z]$" } } } },
            { no: 2, name: "supervisor_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[A-Z][a-zA-Z0-9]*Supervisor$" } } } },
            { no: 3, name: "children", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActorSpawnRequest, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "50" } } } },
            { no: 4, name: "supervision_strategy", kind: "message", T: () => SupervisionStrategy, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "config", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "8192" } } } } } }
        ]);
    }
    create(value?: PartialMessage<BoundedContextSpawnRequest>): BoundedContextSpawnRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.contextName = "";
        message.supervisorType = "";
        message.children = [];
        message.config = {};
        if (value !== undefined)
            reflectionMergePartial<BoundedContextSpawnRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BoundedContextSpawnRequest): BoundedContextSpawnRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string context_name */ 1:
                    message.contextName = reader.string();
                    break;
                case /* string supervisor_type */ 2:
                    message.supervisorType = reader.string();
                    break;
                case /* repeated agency.supervisor.v1.ActorSpawnRequest children */ 3:
                    message.children.push(ActorSpawnRequest.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* agency.supervisor.v1.SupervisionStrategy supervision_strategy */ 4:
                    message.supervisionStrategy = SupervisionStrategy.internalBinaryRead(reader, reader.uint32(), options, message.supervisionStrategy);
                    break;
                case /* map<string, string> config */ 5:
                    this.binaryReadMap5(message.config, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: BoundedContextSpawnRequest["config"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof BoundedContextSpawnRequest["config"] | undefined, val: BoundedContextSpawnRequest["config"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.supervisor.v1.BoundedContextSpawnRequest.config");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: BoundedContextSpawnRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string context_name = 1; */
        if (message.contextName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.contextName);
        /* string supervisor_type = 2; */
        if (message.supervisorType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.supervisorType);
        /* repeated agency.supervisor.v1.ActorSpawnRequest children = 3; */
        for (let i = 0; i < message.children.length; i++)
            ActorSpawnRequest.internalBinaryWrite(message.children[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.supervisor.v1.SupervisionStrategy supervision_strategy = 4; */
        if (message.supervisionStrategy)
            SupervisionStrategy.internalBinaryWrite(message.supervisionStrategy, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> config = 5; */
        for (let k of globalThis.Object.keys(message.config))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.config[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.BoundedContextSpawnRequest
 */
export const BoundedContextSpawnRequest = new BoundedContextSpawnRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BoundedContextSpawnResponse$Type extends MessageType<BoundedContextSpawnResponse> {
    constructor() {
        super("agency.supervisor.v1.BoundedContextSpawnResponse", [
            { no: 1, name: "context_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64" } } } },
            { no: 2, name: "supervisor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "supervisor_pid", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 4, name: "children", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActorSpawnResponse },
            { no: 5, name: "spawned_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<BoundedContextSpawnResponse>): BoundedContextSpawnResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.contextName = "";
        message.supervisorId = "";
        message.supervisorPid = "";
        message.children = [];
        if (value !== undefined)
            reflectionMergePartial<BoundedContextSpawnResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BoundedContextSpawnResponse): BoundedContextSpawnResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string context_name */ 1:
                    message.contextName = reader.string();
                    break;
                case /* string supervisor_id */ 2:
                    message.supervisorId = reader.string();
                    break;
                case /* string supervisor_pid */ 3:
                    message.supervisorPid = reader.string();
                    break;
                case /* repeated agency.supervisor.v1.ActorSpawnResponse children */ 4:
                    message.children.push(ActorSpawnResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp spawned_at */ 5:
                    message.spawnedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.spawnedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BoundedContextSpawnResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string context_name = 1; */
        if (message.contextName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.contextName);
        /* string supervisor_id = 2; */
        if (message.supervisorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.supervisorId);
        /* string supervisor_pid = 3; */
        if (message.supervisorPid !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.supervisorPid);
        /* repeated agency.supervisor.v1.ActorSpawnResponse children = 4; */
        for (let i = 0; i < message.children.length; i++)
            ActorSpawnResponse.internalBinaryWrite(message.children[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp spawned_at = 5; */
        if (message.spawnedAt)
            Timestamp.internalBinaryWrite(message.spawnedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.supervisor.v1.BoundedContextSpawnResponse
 */
export const BoundedContextSpawnResponse = new BoundedContextSpawnResponse$Type();
